import type { DeletedOverlay, ListResult, Overlay, SearchableFilter } from 'common/api/v1/types'
import { EdgeClient } from 'common/generated/edgeClient'
import { OverlaysRequestParams, singleSortQueryFromPaginatedRequestParams } from '../nm-types'

export class OverlaysApi {
  constructor(private readonly edgeClient: EdgeClient) {}

  listOverlays({ filter, name, ...params }: OverlaysRequestParams): Promise<ListResult<Overlay>> {
    const searchFilter: any = {}

    if (name) {
      searchFilter.searchName = name
    }

    if (filter) {
      searchFilter.searchAny = filter
    }

    const query = singleSortQueryFromPaginatedRequestParams<SearchableFilter, string>({
      filter: searchFilter,
      paginatedRequestParams: params,
    })

    return this.edgeClient.listOverlays(query)
  }

  getOverlay(id: string): Promise<Overlay> {
    return this.edgeClient.getOverlay(id)
  }

  updateOverlay(overlay: Overlay): Promise<Overlay> {
    return this.edgeClient.createOverlay(overlay)
  }

  deleteOverlay(id: string): Promise<DeletedOverlay> {
    return this.edgeClient.deleteOverlay(id)
  }
}
